import { Component, OnDestroy, OnInit, HostListener, ElementRef, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth';
import { NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { KlientService } from '../../../@core/http/klient.service';
import { KontaktService } from '../../../@core/http/kontakt.service';
import { HomeRedirectService } from '../../../@core/services/home-redirect.service';
import { Klient, KlientAlternatywny, TypKlienta } from '../../../shared/models/klient.model';
import { Kontakt } from '../../../shared/models/kontakt.model';
import { TokenPayload } from '../../../shared/models/token-payload.model';
import { LogoutConfirmationDialogComponent } from '../logout-confirmation-dialog/logout-confirmation-dialog.component';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() isMainSidebarOpen = false;
  @Input() klient: Klient;
  @Output() onSidebarToggle = new EventEmitter<void>();

  private destroy$: Subject<void> = new Subject<void>();

  user: TokenPayload;
  userMenu: any;
  kontakt: Kontakt;
  opiekunGlownyTelefon: string;
  isAccountSidebarOpen = false;

  klienciAlternatywni: KlientAlternatywny[];

  public constructor(
    private authService: NbAuthService,
    private dialogService: NbDialogService,
    private elementRef: ElementRef,
    private homeRedirectService: HomeRedirectService,
    private klientService: KlientService,
    private kontaktService: KontaktService,
    private router: Router,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.userMenu = this.getUserMenu();
    this.translate.onLangChange.subscribe(() => this.userMenu = this.getUserMenu());

    this.authService.onTokenChange()
      .subscribe((token: NbAuthOAuth2JWTToken) => {
        if (token.isValid()) {
          this.user = token.getAccessTokenPayload();
        }
      });

    this.klientService.getKlienciAlternatywni().subscribe(klienci => {
      this.klienciAlternatywni = klienci;
    });

    this.kontaktService.getKontakt().subscribe(kontakt => {
      this.kontakt = kontakt;

      if (kontakt.opiekunGlownyTelefon) {
        this.opiekunGlownyTelefon = kontakt.opiekunGlownyTelefon;
      } else if (kontakt.opiekunGlownyTelefonKomorkowy) {
        this.opiekunGlownyTelefon = kontakt.opiekunGlownyTelefonKomorkowy;
      }

      // Recalculate header height after contact data loads (might add second row in mobile)
      setTimeout(() => {
        this.updateHeaderHeight();
      }, 0);
    });

  }

  ngAfterViewInit() {
    // Calculate header height after view is initialized
    setTimeout(() => {
      this.updateHeaderHeight();
    }, 0);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    // Recalculate header height on resize
    this.updateHeaderHeight();
  }

  nazwa() {
    if (this.user?.nazwa) {
      return this.user.nazwa;
    } else {
      return this.user?.email;
    }
  }

  toggleSidebar(): boolean {
    this.onSidebarToggle.emit();
    return false;
  }


  private updateHeaderHeight() {
    const headerElement = this.elementRef.nativeElement;
    if (headerElement) {
      const height = headerElement.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  get isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  navigateHome(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Use HomeRedirectService to navigate to appropriate home page based on client type
    this.homeRedirectService.redirectToHome();
    return false;
  }

  toggleAccountSidebar(): boolean {
    this.isAccountSidebarOpen = !this.isAccountSidebarOpen;
    return false;
  }

  closeAccountSidebar() {
    this.isAccountSidebarOpen = false;
  }

  confirmLogout() {
    this.dialogService.open(LogoutConfirmationDialogComponent)
      .onClose.subscribe(confirmed => {
        if (confirmed) {
          this.authService.logout('email').subscribe(result => {
            if (result.isSuccess()) {
              this.router.navigate(['/auth/login']);
            }
          });
        }
        this.closeAccountSidebar();
      });
  }

  private getUserMenu() {
    return [
      {
        title: this.translate.instant('etykieta.wyloguj'),
        link: '/auth/logout',
      },
    ];
  }

  isKFType(): boolean {
    return this.klient?.typ === TypKlienta.KF;
  }

  isKOType(): boolean {
    return this.klient?.typ === TypKlienta.KO;
  }
}
